import * as React from 'react';
import styled from 'styled-components';
import { spaces } from '@99designs/emu/settings';
import { UserAvatar } from '@99designs/users';
import { Designer } from './User';

const Avatars = styled.span`
    display: inline-block;

    > * {
        margin-left: -${spaces['0.75bu']};
        display: inline-block;

        &:first-child {
            margin-left: 0;
        }
    }
`;

const Suffix = styled.span`
    margin-left: ${spaces['0.25bu']};
    vertical-align: middle;
`;

interface Props {
    users: Designer[];
    size: 'extra-small' | 'small';
    limit?: number;
}

function AvatarCollection({ users, size, limit }: Props) {
    const slicedUsers = limit ? users.slice(0, limit) : users;
    const extraUserCount = users.length - slicedUsers.length;

    return (
        <div>
            <Avatars>
                {slicedUsers.map((designer: Designer) => {
                    return <UserAvatar key={designer.id} userId={designer.id} size={size} border />;
                })}
            </Avatars>
            {extraUserCount > 0 && <Suffix>+{extraUserCount}</Suffix>}
        </div>
    );
}

export default AvatarCollection;
